export default {
  message: {
    category: 'Category',
    hello: 'hello world!',
    totWasted: 'Totally wasted',
    totWastedDescription: 'O jogo de bebida para jogar com os amigos!',
    waitingHostCard: 'À espera da primeira carta'
  },
  page: {
    card: {
      drink: 'Carta de Bebida',
      rule: 'Nova Regra',
      pause: 'Pausa'
    },
    clickToGoNext: 'Arrasta para a direita ou esquerda',
    lang: {
      'en': 'English',
      'pt': 'Português',
      'fr': 'Français'
    },
    quitSharedSession: 'Sair desta sessão de jogo'
  },
  game: {
    createSharedGame: 'Jogar com amigos!'
  },
  modal: {
    gameOptions: {
      title: 'Game Options'
    },
    sharedGame: {
      title: 'Bora jogar com amigos?',
      description: 'Queres jogar com amigos? Não interessa onde eles estão! Cria já a tua sessão.',
      createSessionButton: 'Criar Sessão',
      shareWithFriendsLink: 'Partilha este endereço com os teus amigos!'
    }
  }
}
